export const promptIntroduction = `You are a senior software engineer analyzing production reports.

Step 1: Classify as Bug (malfunction/regression), Question (clarification), Suggestion (feature/improvement), or Spam (non-actionable). Output Report type first.

Step 2: Analyze

Bug: list likely causes (ranked), reproduction steps, fixes/mitigations, code examples, needed logs, env notes.
Question: answer concisely, use env/context, suggest docs or debugging.
Suggestion: summarize, assess impact/feasibility, suggest actionable next steps.
Spam: flag with reason, no analysis, optionally discard/review.`;

export const mobileDataPromptTemplate = `## Report data - data automatically collected on the user device at the time of report submission

Title: {{title}}  
Custom fields: {{custom_fields}}  
Metadata: {{metadata}}  
Tags: {{tags}}  
Priority: {{priority}}

Screenshot URL: {{screenshot_url}}  
Video URL: {{video_url}}

Time: {{time}}  
Operating System: {{os}}  
Device: {{device}}  
App Version: {{app_version}}  
Current view: {{current_view}}  

Location: {{location}}  
Timezone: {{timezone}}  
Locale: {{locale}}  

Network status: {{network_status}}  
NFC status: {{nfc_status}}  

Screen resolution: {{screen_resolution}}  
Screen density: {{screen_density}}  
Device orientation: {{device_orientation}}  
Font scale: {{font_scale}}

Authentication: {{authentication}}  
Battery status: {{battery_status}}  
Low power mode: {{low_power_mode}}  
Used storage: {{storage_status}}
Device memory usage: {{used_device_memory}}  
App memory usage: {{used_app_memory}}  
Granted permissions: {{permissions}}

## Activity history - errors happened in app during the session sorted by timestamp.

{{activity_history}}`;

export const webDataPromptTemplate = `## Report data - data automatically collected on the user device at the time of report submission

Title: {{title}}  
Custom fields: {{custom_fields}}  
Metadata: {{metadata}}  
Tags: {{tags}}  
Priority: {{priority}}

Screenshot URL: {{screenshot_url}}  
Video URL: {{video_url}}

URL: {{current_view}}  
Time: {{time}}  
Operating System: {{os}}  
Device: {{device}}  
Browser: {{browser}}  

Location: {{location}}  
Timezone: {{timezone}}  
Locale: {{locale}}  

Network status: {{network_status}}  

Screen resolution: {{screen_resolution}}  
Browser resolution: {{browse_resolution}}  
Mobile mode: {{is_mobile}}
Cookies enabled: {{cookies_enabled}}  
Device orientation: {{device_orientation}}  
Font scale: {{font_scale}}

Battery status: {{battery_status}}  
Granted permissions: {{permissions}}

## Activity history - errors happened in app during the session sorted by timestamp.

{{activity_history}}`;

export const promptFinalInstructions = `## Instructions

- Output Report type first.
- Analyze according to Report type.
- Be actionable, structured, and environment-aware.
- Rank possible root causes by likelihood.
- Separate facts from assumptions.`;

export const promptVersion = `prompt-version: 1.0.0`;
